/**
 * The collection of i18n strings.
 *
 * @since 0.1.0
 */
export const I18N = {
  search       : 'Search',
  searchToolbar: 'Search/Replace Toolbar',
  wholeWord    : 'Match Whole Word',
  prevMatch    : 'Previous Match',
  nextMatch    : 'Next Match',
  replace      : 'Replace',
  replaceAll   : 'Replace All',
  matchCase    : 'Match Case',
  regexp       : 'Regex',
  noResults    : 'No results',
};
